import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'bidi-side-menu-left',
  templateUrl: './side-menu-left.component.html',
  styleUrls: ['./side-menu-left.component.scss']
})
export class SideMenuLeftComponent {
  @Output() toggle = new EventEmitter();
  @Input() deployed = false;

  unclicked = true;
  changeBurger = false;
  onMenuOver() {
    this.deployed = !this.deployed;
  }

  expandMenu() {
    this.changeBurger = !this.changeBurger;

    this.toggle.emit(!this.deployed);

  }
}
